import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

interface PaymentProviderStatementParams {
  format?: string;
  totalDays: number;
}

export const paymentProviderStatementAPI = async (
  params: PaymentProviderStatementParams,
) => {
  const response = await baseAPI.get<string>(
    'reporting/payment-provider-statement',
    {
      params,
      responseType: 'text',
    },
  );
  return response.data;
};

export const usePaymentProviderStatement = (
  params: PaymentProviderStatementParams,
) => {
  return useQuery({
    queryKey: [
      KEYS.PAYMENT_PROVIDER_STATEMENT,
      Number(params.totalDays),
      params.format ?? 'csv',
    ],
    queryFn: () => paymentProviderStatementAPI(params),
    enabled: !!params.totalDays,
  });
};
